<dx-scroll-view [height]="(windowSize.contentHeight ?? 0) - 75">
  <div class="form">
    <div class="dx-fieldset">
      <!-- Permetti riordinamento delle colonne -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Abilita riordinamento delle colonne mediante drag and drop
        </div>
        <div class="dx-field-value" style="width: 30%">
          <dx-switch [(value)]="gridConf.allowColumnReordering"></dx-switch>
        </div>
      </div>
      <!-- columnHidingEnabled -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Permetti di nascondere le colonne automaticamente su schermi piccoli
          oppure quando la somma delle larghezze fisse impostate supera la
          larghezza schermo
        </div>
        <div class="dx-field-value" style="width: 30%">
          <dx-switch [(value)]="gridConf.columnHidingEnabled"></dx-switch>
        </div>
      </div>
      <!-- Permetti ridimensionamento delle colonne -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Abilita ridimensionamento delle colonne
        </div>
        <div class="dx-field-value" style="width: 30%">
          <dx-switch [(value)]="gridConf.allowColumnResizing"></dx-switch>
        </div>
      </div>
      <!-- Ridimensionamento automatico -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Ridimensionamento automatico in base al contenuto delle celle (valido
          per colonne senza dimensione fissata). Se la somma delle dimensioni
          supera la larghezza dello schermo, appare barra di scorrimento
          orizzontale
        </div>
        <div class="dx-field-value" style="width: 30%">
          <dx-switch [(value)]="gridConf.columnAutoWidth"></dx-switch>
        </div>
      </div>
      <!-- Tipo di resize -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Tipo di ridimensionamento (cambia dimensione della colonna successiva
          o di tutta la grid)
        </div>
        <div class="dx-field-value" style="width: 30%">
          <sia-select-box
            #selectColumnResizingMode
            [(value)]="gridConf.columnResizingMode"
            [selectBoxOptions]="{
              value: gridConf.columnResizingMode,
              fixedDataSource: gridConfColumnResizingModeTypes,
            }"
          ></sia-select-box>
        </div>
      </div>

      <!-- Larghezza minima della colonna -->
      <div class="dx-field">
        <div class="dx-field-label sia-conf-content" style="width: 70%" appI18n>
          Larghezza minima della colonna
        </div>
        <div class="dx-field-value" style="width: 30%">
          <dx-number-box
            [(value)]="gridConf.columnMinWidthNumber"
            [showSpinButtons]="true"
            [showClearButton]="true"
          ></dx-number-box>
        </div>
      </div>
    </div>
  </div>
</dx-scroll-view>
